/* TradePro Cookie / Privacy Consent v4 — callback-driven Shopify Customer Privacy API state. */

(function () {
  var root = document.querySelector('[data-tradepro-cookie-consent]');
  if (!root) return;

  var enabled = root.getAttribute('data-enabled') === 'true';
  var forceShow = root.getAttribute('data-force-show') === 'true';
  var dialog = root.querySelector('[data-tradepro-cookie-dialog]');
  var configureButton = root.querySelector('[data-tradepro-cookie-configure]');
  var acceptButton = root.querySelector('[data-tradepro-cookie-accept]');
  var rejectButton = root.querySelector('[data-tradepro-cookie-reject]');
  var saveButton = root.querySelector('[data-tradepro-cookie-save]');
  var errorMessage = root.querySelector('[data-tradepro-cookie-error]');
  var analyticsInput = root.querySelector('[data-tradepro-cookie-purpose="analytics"]');
  var marketingInput = root.querySelector('[data-tradepro-cookie-purpose="marketing"]');
  var preferencesInput = root.querySelector('[data-tradepro-cookie-purpose="preferences"]');
  var openButtons = document.querySelectorAll('[data-tradepro-cookie-open]');
  var actionButtons = root.querySelectorAll('button');
  var lastTrigger = null;

  function setConfigureState(isConfiguring) {
    root.classList.toggle('is-configuring', isConfiguring);
    if (configureButton) configureButton.setAttribute('aria-expanded', isConfiguring ? 'true' : 'false');
  }

  function setBusy(isBusy) {
    actionButtons.forEach(function (button) {
      button.disabled = isBusy;
      button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function clearError() {
    root.classList.remove('has-error');
    if (errorMessage) errorMessage.hidden = true;
  }

  function showError(error) {
    root.classList.add('has-error');
    if (errorMessage) errorMessage.hidden = false;
    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn('TradePro cookie consent could not be saved.', error || (window.KitomasgotaI18n?.text("Unknown error") ?? 'Unknown error'));
    }
  }

  function getConsent(customerPrivacy) {
    if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') return {};
    try {
      return customerPrivacy.currentVisitorConsent() || {};
    } catch (error) {
      return {};
    }
  }

  function isDecisionValue(value) {
    return value === 'yes' || value === 'no';
  }

  function hasCompleteDecision(consent) {
    return isDecisionValue(consent.analytics)
      && isDecisionValue(consent.marketing)
      && isDecisionValue(consent.preferences);
  }

  function consentMatches(consent, decision) {
    return consent.analytics === (decision.analytics ? 'yes' : 'no')
      && consent.marketing === (decision.marketing ? 'yes' : 'no')
      && consent.preferences === (decision.preferences ? 'yes' : 'no');
  }

  function syncInputs(customerPrivacy) {
    var consent = getConsent(customerPrivacy);
    if (analyticsInput) analyticsInput.checked = consent.analytics === 'yes';
    if (marketingInput) marketingInput.checked = consent.marketing === 'yes';
    if (preferencesInput) preferencesInput.checked = consent.preferences === 'yes';
    return consent;
  }

  function showBanner(options) {
    options = options || {};
    root.hidden = false;
    clearError();
    setConfigureState(!!options.configure);
    window.requestAnimationFrame(function () {
      root.classList.add('is-visible');
      if (options.focus && dialog) dialog.focus({ preventScroll: true });
    });
  }

  function hideBanner() {
    root.classList.remove('is-visible');
    setConfigureState(false);
    clearError();
    setBusy(false);
    window.setTimeout(function () {
      root.hidden = true;
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    }, 220);
  }

  function loadCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(null, window.Shopify.customerPrivacy);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          callback(error || new Error('Customer Privacy API unavailable'));
          return;
        }
        callback(null, window.Shopify.customerPrivacy);
      });
      return;
    }
    callback(new Error('Shopify loadFeatures unavailable'));
  }

  function applyConsent(decision) {
    clearError();
    setBusy(true);

    loadCustomerPrivacy(function (loadError, customerPrivacy) {
      if (loadError || !customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
        setBusy(false);
        showError(loadError || new Error('Customer Privacy API unavailable'));
        return;
      }

      try {
        customerPrivacy.setTrackingConsent({
          analytics: !!decision.analytics,
          marketing: !!decision.marketing,
          preferences: !!decision.preferences
        }, function (result) {
          if (result && result.error) {
            setBusy(false);
            showError(result.error);
            return;
          }

          setBusy(false);
          syncInputs(customerPrivacy);
          hideBanner();
        });
      } catch (consentError) {
        setBusy(false);
        showError(consentError);
      }
    });
  }

  if (configureButton) configureButton.addEventListener('click', function () {
    clearError();
    setConfigureState(!root.classList.contains('is-configuring'));
  });
  if (acceptButton) acceptButton.addEventListener('click', function () {
    applyConsent({ analytics: true, marketing: true, preferences: true });
  });
  if (rejectButton) rejectButton.addEventListener('click', function () {
    applyConsent({ analytics: false, marketing: false, preferences: false });
  });
  if (saveButton) saveButton.addEventListener('click', function () {
    applyConsent({
      analytics: analyticsInput ? analyticsInput.checked : false,
      marketing: marketingInput ? marketingInput.checked : false,
      preferences: preferencesInput ? preferencesInput.checked : false
    });
  });

  openButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (!enabled) return;
      lastTrigger = button;
      loadCustomerPrivacy(function (error, customerPrivacy) {
        if (!error) syncInputs(customerPrivacy);
        showBanner({ configure: true, focus: true });
      });
    });
  });

  document.addEventListener('tradepro:open-cookie-preferences', function () {
    if (!enabled) return;
    loadCustomerPrivacy(function (error, customerPrivacy) {
      if (!error) syncInputs(customerPrivacy);
      showBanner({ configure: true, focus: true });
    });
  });

  document.addEventListener('visitorConsentCollected', function () {
    loadCustomerPrivacy(function (error, customerPrivacy) {
      if (error) return;
      var consent = syncInputs(customerPrivacy);
      if (hasCompleteDecision(consent) && root.classList.contains('is-visible')) hideBanner();
    });
  });

  if (!enabled) return;
  loadCustomerPrivacy(function (error, customerPrivacy) {
    if (error) {
      if (forceShow) showBanner({ configure: false, focus: false });
      return;
    }

    var consent = syncInputs(customerPrivacy);

    if (!forceShow && hasCompleteDecision(consent)) {
      root.hidden = true;
      return;
    }

    var shouldShow = forceShow;
    if (!shouldShow && typeof customerPrivacy.shouldShowBanner === 'function') {
      try {
        shouldShow = !!customerPrivacy.shouldShowBanner();
      } catch (bannerError) {
        shouldShow = !hasCompleteDecision(consent);
      }
    }

    if (shouldShow) showBanner({ configure: false, focus: false });
  });
})();
